module.exports = __webpack_public_path__ + "static/media/display-suite-17.cb55be1c.jpg";